import { Injectable } from '@angular/core';
import {
  B2bDataService,
  SFSOptions,
} from '@nimmsta/ng-commons-lib/data-access';
import { DeviceStatus, Pageable } from '@nimmsta/ng-commons-lib/models';
import { map, Observable } from 'rxjs';
import { LightTag } from '../models/lighttag';

@Injectable({
  providedIn: 'root',
})
export class LightTagService extends B2bDataService<LightTag> {
  protected override get apiEndpoint(): string {
    return '/light-tags';
  }

  override list(
    options: Partial<SFSOptions> = {},
  ): Observable<Pageable<LightTag>> {
    return this.http
      .get<Pageable<LightTag>>(this.baseUrl + this.apiEndpoint, {
        params: this.getParams(options).set('includeChildren', true),
      })
      .pipe(
        map((page) => {
          page.content = page.content.map((item) =>
            this.loadedDataTransform(item),
          );
          return page;
        }),
      );
  }

  override get(id: string): Observable<LightTag> {
    return this.http
      .get<LightTag>(
        `${this.baseUrl + this.apiEndpoint}/${id}?includeChildren=true`,
      )
      .pipe(map((item) => this.loadedDataTransform(item)));
  }

  listAll(options: Partial<SFSOptions> = {}): Observable<Pageable<LightTag>> {
    const params = this.getParams(options);
    return this.http
      .get<Pageable<LightTag>>(`${this.baseUrl + this.apiEndpoint}/all`, {
        params,
      })
      .pipe(
        map((page) => {
          page.content = page.content.map((item) =>
            this.loadedDataTransform(item),
          );
          return page;
        }),
      );
  }

  updateStatus(deviceId: string, status: DeviceStatus): Observable<LightTag> {
    return this.http
      .patch<LightTag>(
        `${this.baseUrl + this.apiEndpoint}/${deviceId}/status?includeChildren=true`,
        { status },
        { headers: this.getHeades() },
      )
      .pipe(map((item) => this.loadedDataTransform(item)));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  override create(object: LightTag): Observable<LightTag> {
    throw new Error('Method not implemented.');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  override update(object: LightTag): Observable<LightTag> {
    throw new Error('Method not implemented.');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  override delete(object: LightTag): Observable<void> {
    throw new Error('Method not implemented.');
  }
}
